import { axiosInstance } from "../Components/axiosInstance.js";

export async function getClientConfig() {
  const apiUrl = process.env.REACT_APP_API_URL;

  if (!apiUrl) {
    return null;
  }

  const response = await axiosInstance.get(apiUrl);
  return response.data;
}

export async function getGoogleMapsApiKey() {
  const config = await getClientConfig();
  return config?.GOOGLE_APIKEY ?? null;
}
